import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  text-decoration: none;\n  left: -999px;\n  position: absolute;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  z-index: -999;\n  color: primary;\n\n  &:focus {\n    background-color: background;\n    border-radius: base;\n    left: auto;\n    top: auto;\n    height: auto;\n    width: max-content;\n    overflow: auto;\n    padding: 2;\n    margin: 2;\n    text-align: center;\n    z-index: 999;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n      overflow-x: auto;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: background;\n  border-bottom-style: solid;\n  border-bottom-width: base;\n  border-bottom-color: layout-border;\n  padding: 2 0;\n  height: 50;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { useStaticQuery } from 'gatsby';
import styled, { Box, useColorMode, down, css } from '@xstyled/styled-components';
import { ScreenContainer } from './ScreenContainer';
import { DocSearch } from './DocSearch';
import { NavLink } from './Nav';
import { AppNav } from './AppNav';
var AppHeaderQuery = "1022386572";
var OuterHeader = styled.header(_templateObject(), down('sm', css(_templateObject2())));
var NavSkipLink = styled.a(_templateObject3());

function useLogo(logos) {
  var _useColorMode = useColorMode(),
      mode = _useColorMode[0];

  switch (mode) {
    case 'dark':
      return logos.find(function (logo) {
        return logo.name === 'logo-nav-dark';
      }) || logos.find(function (logo) {
        return logo.name === 'logo-nav';
      }) || null;

    case 'light':
    default:
      return logos.find(function (logo) {
        return logo.name === 'logo-nav-light';
      }) || logos.find(function (logo) {
        return logo.name === 'logo-nav';
      }) || null;
  }
}

export function AppHeader() {
  var data = useStaticQuery(AppHeaderQuery);
  var logo = useLogo(data.logos.nodes);
  return /*#__PURE__*/React.createElement(OuterHeader, null, /*#__PURE__*/React.createElement(ScreenContainer, null, /*#__PURE__*/React.createElement(NavSkipLink, {
    tabindex: "0",
    href: "#main"
  }, "Skip to content"), /*#__PURE__*/React.createElement(Box, {
    row: true,
    alignItems: "center",
    flexWrap: "nowrap",
    mx: -2
  }, /*#__PURE__*/React.createElement(Box, {
    col: true,
    px: 2,
    display: "flex"
  }, /*#__PURE__*/React.createElement(NavLink, {
    row: true,
    display: "inline-flex",
    alignItems: "center",
    flexWrap: "nowrap",
    mx: -2,
    to: "/"
  }, logo ? /*#__PURE__*/React.createElement(Box, {
    col: "auto",
    px: 2,
    height: 32,
    forwardedAs: "img",
    src: logo.publicURL,
    alt: data.site.siteMetadata.title
  }) : /*#__PURE__*/React.createElement(Box, {
    col: "auto",
    flex: "0 1 auto",
    px: 2,
    forwardedAs: "h2",
    alignItems: "center",
    fontSize: 18,
    m: 0
  }, data.site.siteMetadata.title))), data.site.siteMetadata.docSearch ? /*#__PURE__*/React.createElement(Box, {
    col: "auto",
    px: 2,
    display: {
      xs: 'none',
      md: 'block'
    }
  }, /*#__PURE__*/React.createElement(DocSearch, data.site.siteMetadata.docSearch)) : null, /*#__PURE__*/React.createElement(AppNav, {
    col: "auto",
    px: 2
  }))));
}